import { createSlice } from '@reduxjs/toolkit'
import { isUserAuthorizedAction, loginAction, verifyUserAction } from '../actions/authActions';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        status: 'idle',
        error: "" | null,
        user: {}
    },
    reducers: {
        login: (state, action) => {
            return state
        },
        setUser: (state, action) => {
            state.user = action.payload
        }
    },
    extraReducers(builder) {
        // Login 
        builder.addCase(loginAction.pending, (state, action) => {
            state.status = "pending"
        })
            .addCase(loginAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                state.user = action.payload
            })
            .addCase(loginAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to fetch"
            })
            // Verify 
            .addCase(verifyUserAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(verifyUserAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                // state.user = action.payload
            })
            .addCase(verifyUserAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to verify"
            })
            // Is Authorized
            .addCase(isUserAuthorizedAction.pending, (state, action) => {
                state.status = "pending"
            })
            .addCase(isUserAuthorizedAction.fulfilled, (state, action) => {
                state.status = "succeeded"
                // state.user = action.payload
            })
            .addCase(isUserAuthorizedAction.rejected, (state, action) => {
                state.status = "failed"
                state.error = "Unable to verify"
            })
    }
})

export const { login } = authSlice.actions

export default authSlice.reducer